export enum StoreStatuses {
  "ACTIVE" = "ACTIVE",
  "INACTIVE" = "INACTIVE",
}
